export default __webpack_public_path__ + "static/media/97.34bd9575.gif";